import isPropValid from '@emotion/is-prop-valid';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Property } from 'csstype';
import {
  fontWeight,
  FontWeightProps,
  lineHeight,
  LineHeightProps,
  space,
  SpaceProps,
  textAlign,
  TextAlignProps,
  variant,
} from 'styled-system';

import { theme } from '@/styles/theme';

export type TextUseTypes =
  | 'xs-N'
  | 'xs-B'
  | 's-N'
  | 's-B'
  | 'm-N'
  | 'm-N-tight'
  | 'm-B-tight'
  | 'm-B'
  | 'l-N'
  | 'l-B';
export interface Props
  extends FontWeightProps, LineHeightProps, SpaceProps, TextAlignProps {
  use?: TextUseTypes;
  whiteSpace?: Property.WhiteSpace;
  wordBreak?: Property.WordBreak;
  block?: boolean;
  color?: keyof typeof theme.colors.text;
  userSelect?: boolean;
}

export const Text = styled('p', {
  shouldForwardProp: isPropValid,
})<Props>(
  ({ whiteSpace, wordBreak, block, color, userSelect }) =>
    css({
      whiteSpace,
      wordBreak,
      display: block ? 'block' : 'inline-block',
      userSelect: userSelect ? 'none' : 'auto',
      margin: 0,
      padding: 0,
      color: color ? theme.colors.text[color] : theme.colors.text.default,
    }),
  ({ theme }) => [
    fontWeight,
    space,
    textAlign,
    lineHeight,
    variant({
      prop: 'use',
      variants: {
        'xs-N': css({
          fontSize: theme.fontSizes.xs,
          fontWeight: theme.fontWeights.default,
          lineHeight: theme.lineHeights.m,
        }),
        'xs-B': css({
          fontSize: theme.fontSizes.xs,
          fontWeight: theme.fontWeights.bold,
          lineHeight: theme.lineHeights.m,
        }),
        's-N': css({
          fontSize: theme.fontSizes.s,
          fontWeight: theme.fontWeights.default,
          lineHeight: theme.lineHeights.m,
        }),
        's-B': css({
          fontSize: theme.fontSizes.s,
          fontWeight: theme.fontWeights.bold,
          lineHeight: theme.lineHeights.m,
        }),
        'm-N': css({
          fontSize: theme.fontSizes.m,
          fontWeight: theme.fontWeights.default,
          lineHeight: theme.lineHeights.m,
        }),
        'm-N-tight': css({
          fontSize: theme.fontSizes.m,
          fontWeight: theme.fontWeights.default,
          lineHeight: theme.lineHeights.s,
        }),
        'm-B': css({
          fontSize: theme.fontSizes.m,
          fontWeight: theme.fontWeights.bold,
          lineHeight: theme.lineHeights.m,
        }),
        'm-B-tight': css({
          fontSize: theme.fontSizes.m,
          fontWeight: theme.fontWeights.bold,
          lineHeight: theme.lineHeights.s,
        }),
        'l-B': css({
          fontSize: theme.fontSizes.l,
          fontWeight: theme.fontWeights.bold,
          lineHeight: theme.lineHeights.m,
        }),
      },
    }),
  ]
);
